import React from 'react';
import AssessmentTool from './AssessmentTool';
import { nistCsfMeta, nistCsfQuestions, computeNistCsfResult } from '../config/nistCsfConfig';

const NistCsfAssessmentPage = () => (
  <AssessmentTool
    meta={nistCsfMeta}
    questions={nistCsfQuestions}
    computeResult={computeNistCsfResult}
  />
);

export default NistCsfAssessmentPage;
